<template>
  <v-autocomplete
    :value="initValue"
    @change="onChange"
    dense
    :items="items"
    :label="label"
    :disabled="disabled"
    outlined
    clearable
  ></v-autocomplete>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    disabled: Boolean,
    initValue: String,
    entity: String,
    label: String
  },
  name: 'SelectEntity',
  data() {
    return {
      items: []
    }
  },
  async mounted() {
    if (!this.curentItems.length) await this.fetchItems()
    this.items = this.curentItems.map(i => {
      let textVal = i.name
      if (this.entity === 'productModels') textVal = `${i.code} / ${i.description}`
      return {
        text: textVal,
        value: i._id
      }
    })
  },
  computed: mapState({
    curentItems(state) {
      return state[this.entity].items
    }
  }),
  methods: {
    ...mapActions({
      fetchItems(dispatch) {
        return dispatch(this.entity + '/fetchItems', { _limit: -1 })
      }
    }),
    onChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
